/* Rare Food Shop · Where Every Celebration Begins — theme behaviour */
(function () {
  'use strict';
  var R = window.RFS || {};

  function formatMoney(cents) {
    var fmt = R.moneyFormat || '₱{{amount}}';
    var n = (cents / 100).toFixed(2).split('.');
    var withCommas = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + n[1])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1]);
  }

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('RfsToast');
    if (!t) return;
    document.getElementById('RfsToastText').textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* AJAX add to cart: any form[data-rfs-add] */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-rfs-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch((R.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || 'Sorry, we could not add that.'); return; }
        var title = res.j.product_title || 'Item';
        var qty = res.j.quantity && res.j.quantity > 1 ? ' × ' + res.j.quantity : '';
        toast('Added: ' + title + qty);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var wrap = b.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product: live "Add to cart · total" label */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var input = form.querySelector('input[name="quantity"]');
    var label = form.querySelector('[data-add-total]');
    var price = parseInt(form.getAttribute('data-price'), 10);
    if (!input || !label || !price) return;
    input.addEventListener('change', function () {
      label.textContent = formatMoney(price * Math.max(1, parseInt(input.value, 10) || 1));
    });
  });

  /* Product thumbnails */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('[data-main-img]');
      if (!main) return;
      main.src = btn.getAttribute('data-thumb');
      main.removeAttribute('srcset');
      document.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
    });
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Cart page: auto-update on quantity change */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var update = cartForm.querySelector('[name="update"]');
        if (update) update.click(); else cartForm.submit();
      }, 350);
    });
  }

  /* Product recommendations ("Pairs well with") */
  document.querySelectorAll('[data-recs-url]').forEach(function (el) {
    fetch(el.getAttribute('data-recs-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recs-url]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.hidden = false; }
      })
      .catch(function () {});
  });
})();
